import { Component, Prop, Vue } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import FormInput2 from '@/components/forms/FormInput2.vue';
import { openTermsModal } from '@/modals/termsModal';
@Component({
    name: 'TermsCheckbox',
    components: {
        FormInput2,
    },
})
export default class default_1 extends Vue {
    @Prop({ default: false })
    value;
    viewingIsRequired = !environment.web.terms_and_conditions?.viewing_is_optional;
    t;
    get internalValue() {
        return this.value;
    }
    set internalValue(v) {
        this.$emit('input', v);
    }
    onClick(event) {
        if (this.clickShouldShowTermsModal(event)) {
            event.preventDefault();
            // Uncheck the terms and conditions checkbox.
            this.internalValue = false;
            // Ignore declined terms and conditions if opened via checkbox.
            this.openTermsModal().catch(() => null);
        }
    }
    clickShouldShowTermsModal(event) {
        if (this.viewingIsRequired) {
            return true;
        }
        else {
            const el = event.target;
            return 'a' === el.tagName.toLowerCase();
        }
    }
    get checkboxLabel() {
        return this.wrapLabelInLink ? `<a>${this.t.checkboxLabel}</a>` : this.t.checkboxLabel;
    }
    get wrapLabelInLink() {
        if (this.viewingIsRequired) {
            return false;
        }
        else {
            // Viewing terms & conditions is optional.
            // Ensure a link exists to view them even if the label language is overridden and omits an <a> tag.
            const el = document.createElement('div');
            el.innerHTML = this.t.checkboxLabel;
            return el.querySelector('a') === null;
        }
    }
    validate() {
        if (!this.internalValue) {
            // Open the terms dialog if they have not been accepted yet.
            return this.openTermsModal();
        }
        else {
            return Promise.resolve();
        }
    }
    openTermsModal() {
        return new Promise((resolve, reject) => {
            openTermsModal((data) => {
                this.internalValue = data?.accepted;
                if (data?.accepted) {
                    /* eslint-disable no-console */
                    console.log('Accepted terms and conditions');
                    resolve();
                }
                else {
                    reject({ validationError: true });
                }
            });
        });
    }
}
